export default {"src":"/_next/static/media/search.2536e02f.svg","height":25,"width":24};